var _defs, _rect, _g, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignaturePortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7499d6;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #445689;\n      }\n\n      .cls-3 {\n        fill: #d0f19a;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 256,
    height: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.22,115.39c5.1,3.3,10.54,2.83,15.91,2.83,10.89,0,21.78,0,32.67,0h3.1c.05,7.19,2.31,13.26,8.09,17.63,3.98,3.01,8.48,4.29,13.46,3.96,10.75-.7,17.6-8.44,18.77-21.59h2.73c10.89,0,21.78,0,32.67,0,2.79,0,5.61.19,8.35-.18,2.61-.36,5.14-1.33,7.83-2.07.03.64.1,1.39.1,2.15,0,14.79.01,29.57,0,44.36,0,7.09-3.65,10.7-10.82,10.71-7.06.02-14.11-.05-21.17.04-1.64.02-2.39-.56-3.13-2-7.83-15.28-20.34-23.68-37.58-23.71-17.33-.03-29.96,8.31-37.83,23.72-.73,1.43-1.48,2.02-3.13,1.99-6.62-.1-13.24-.01-19.86-.05-6.4-.04-10.26-3.88-10.27-10.23-.02-15.05,0-30.1,0-45.15,0-.66.06-1.32.12-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.05,110.29c0-4.47.02-8.72,0-12.97-.03-5.74-2.96-8.67-8.72-8.69-7.58-.03-15.16-.03-22.74,0-5.59.02-8.52,2.95-8.6,8.55-.06,4.17-.05,8.35-.09,12.52,0,.15-.13.3-.33.73h-2.42c-12.72,0-25.44,0-38.16,0-7.17,0-10.89-3.77-10.9-10.99,0-6.26-.02-12.53,0-18.79.02-6.48,3.92-10.36,10.44-10.37,40.95,0,81.9,0,122.85,0,6.7,0,10.49,3.8,10.51,10.53.02,6.61.04,13.22-.01,19.83-.05,5.69-3.99,9.73-9.7,9.76-13.59.07-27.18.02-40.78.02-.34,0-.67-.06-1.36-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.64,62.38h-69.03c-1.96-8.14,4.94-17.69,13.89-19.26,1.11-.2,2.25-.37,3.37-.37,11.41-.03,22.82-.14,34.22.02,10.77.14,18.29,8.56,17.56,19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.75,96.49h24.3c.07.73.19,1.39.19,2.05.01,6.94.03,13.89,0,20.83-.04,7.31-5.37,12.86-12.26,12.8-6.83-.05-12.14-5.47-12.21-12.62-.07-7.61-.02-15.23-.02-23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.37,154.12c-13.21-.25-24.45,10.52-24.71,23.68-.27,13.86,10.28,24.86,24.14,25.19,13.17.31,24.46-10.57,24.76-23.88.3-13.56-10.52-24.74-24.2-24.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.4,180.05c0,2.53,0,5.07,0,7.6,0,.58-.14.72-.71.72-1.08,0-2.15,0-3.23,0-.54,0-.69-.15-.69-.67,0-5.13,0-10.26,0-15.39,0-.49.16-.66.65-.66,1.12,0,2.24,0,3.35,0,.46,0,.63.17.63.64,0,2.59,0,5.17,0,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.87,182.96c0,1.58,0,3.15,0,4.73,0,.52-.16.69-.68.69-1.1,0-2.19,0-3.29,0-.5,0-.67-.17-.67-.68,0-3.16,0-6.33,0-9.49,0-.52.17-.69.69-.69,1.09,0,2.17,0,3.26,0,.54,0,.7.17.7.71,0,1.58,0,3.15,0,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.89,184.33c0-1.1,0-2.19,0-3.29,0-.52.16-.69.69-.69,1.1,0,2.19,0,3.29,0,.5,0,.67.17.67.67,0,2.22,0,4.45,0,6.67,0,.5-.17.67-.67.67-1.11,0-2.21,0-3.32,0-.48,0-.65-.18-.65-.66,0-1.13,0-2.26,0-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.38,164.94c-.62.24-1.17.45-1.71.65-.39.15-.68.05-.79-.27-.11-.3.04-.53.44-.69.85-.33,1.71-.65,2.56-.98.52-.2.72-.11.91.4.34.88.68,1.77,1.01,2.65.16.44-.13.85-.53.74-.16-.05-.33-.23-.41-.39-.22-.48-.4-.98-.61-1.52-.18.35-.32.66-.49.97-3.5,6.51-8.83,10.69-16,12.46-1.36.33-2.77.43-4.16.63-.1.02-.21.01-.32.01-.33,0-.55-.18-.57-.47-.02-.29.2-.52.54-.55.68-.06,1.36-.1,2.03-.19,4.08-.55,7.77-2.07,11.04-4.57,2.99-2.28,5.28-5.13,6.9-8.53.04-.09.08-.19.16-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.8,185.24c0-.83,0-1.66,0-2.49,0-.46.18-.64.63-.64,1.12,0,2.24,0,3.35,0,.46,0,.65.17.65.63,0,1.67,0,3.34,0,5.02,0,.45-.18.62-.62.62-1.13,0-2.26,0-3.39,0-.46,0-.63-.18-.63-.64,0-.83,0-1.66,0-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.69,190.5c-3.88,0-7.75,0-11.63,0-.16,0-.32,0-.48-.04-.24-.06-.37-.24-.36-.5.01-.25.15-.42.4-.47.1-.02.21-.02.32-.02,7.83,0,15.66,0,23.48,0,.1,0,.19,0,.29.01.27.04.42.2.44.47.01.28-.14.47-.42.52-.13.03-.28.02-.41.02-3.88,0-7.75,0-11.63,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 145.5,
    y: 188.95,
    width: 5.77,
    height: 10.57,
    transform: "translate(-96.04 196.07) rotate(-53.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.25,194.55h5.77v20.68c0,1.32-1.07,2.38-2.38,2.38h-1c-1.32,0-2.38-1.07-2.38-2.38v-20.68h0Z",
    transform: "translate(-99.22 213.38) rotate(-53.05)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 96,
    cy: 172,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 158,
    cy: 172,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignaturePortfolio);
export default __webpack_public_path__ + "static/media/Signature Portfolio.d466d45f4129e7fd6603793ff12d6a62.svg";
export { ForwardRef as ReactComponent };